function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as l } from "react/jsx-runtime";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as o } from "../../skins/skin-contract.css-mistica.js";
const n = (_param)=>{
    var { color: c , size: r = 24  } = _param, e = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const a = s(), t = c !== null && c !== void 0 ? c : a ? o.colors.inverse : o.colors.neutralHigh;
    return /* @__PURE__ */ l("svg", _object_spread_props(_object_spread({
        width: r,
        height: r,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: /* @__PURE__ */ l("path", {
            fill: t,
            d: "M19.496 6.012c1.205 1.23 1.989 2.863 2.328 4.846.075.417-.04.857-.314 1.205a1.566 1.566 0 01-1.196.557l-7.605-.02v7.003c0 .56.465 1.017 1.034 1.017.568 0 1.033-.457 1.033-1.017 0-.336.278-.61.62-.61.341 0 .618.274.618.61 0 1.235-1.02 2.241-2.271 2.241-1.236 0-2.247-.978-2.272-2.19-.003-.014-.003-.028-.003-.042v-7.014l-7.762-.023a1.604 1.604 0 01-.815-.232 1.57 1.57 0 01-.361-.308 1.524 1.524 0 01-.345-1.239c.353-1.983 1.151-3.607 2.37-4.829 1.63-1.647 3.96-2.52 6.913-2.607v-.594c0-.336.277-.611.62-.611.34 0 .618.275.618.61v.595c2.905.128 5.185 1.014 6.79 2.652zM3.544 11.306a.342.342 0 00.168.045l1.795.006c.597-3.35 2.286-5.364 3.78-6.521-1.578.339-2.872 1-3.85 1.986-1.042 1.042-1.725 2.45-2.033 4.187a.294.294 0 00.07.236c.028.03.053.05.066.059l.004.002zm17.003-.016a.31.31 0 00.058-.225c-.297-1.742-.969-3.156-1.997-4.207-.935-.955-2.165-1.608-3.658-1.97 1.415 1.141 2.947 3.127 3.549 6.502l1.812.006c.065 0 .16-.02.236-.107zm-7.84-6.373v6.462l4.534.011c-.823-4.207-3.243-5.874-4.535-6.473zm-1.242-.008c-1.297.633-3.904 2.389-4.703 6.453l4.703.014V4.91z"
        })
    }));
}, f = n;
export { f as default };
